import { Button, message, Tooltip } from "antd";
import React, { useRef } from "react";
import { BsCalendar3 } from "react-icons/bs";
import { connect, useDispatch } from "react-redux";
import { initNewLayer, uniqueID } from "../../../Utilities/helper";
import { ASSET_URL, AWS_API } from "../../../../../config";
import axios from "axios";
import { pick } from "lodash";
import { ARTWORK } from "../../../../../types";
import { MdQrCode } from "react-icons/md";
import QRCodeStyling from "qr-code-styling";
import { uuid } from "short-uuid";

const upload = async (base64) => {
  var file = await fetch(base64)
    .then((res) => res.arrayBuffer())
    .then((buf) => new File([buf], "tmp.png", { type: "image/png" }));
  var signedUrl = await getSignedUrl(file.type);
  await axios
    .put(signedUrl.url, file, {
      headers: {
        "Content-Type": file.type,
      },
    })
    .catch((err) => console.error(err));
  return {
    id: uniqueID(),
    key: signedUrl.key,
  };
};

const getSignedUrl = async (mime) => {
  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: headers,
    redirect: "follow",
  };
  var signedUrl = null;
  await fetch(`${AWS_API}/signedUrl?type=${mime}`, requestOptions)
    .then((response) => response.json())
    .then((res) => (signedUrl = res))
    .catch((err) => console.error(err));
  return signedUrl;
};

const AddQRCodeLayer = (props) => {
  const { layers } = props;

  const dispatch = useDispatch();

  const addImageQRCode = () => {
    const key = "addLayerQRCode";
    message.loading({
      content: "Start generating QR codes...",
      key,
      duration: 0,
    });

    const configs = {
      backgroundOptions: {
        color: "#ffffff",
        colorType: "single-color",
      },
      shape: "square",
      borderRadius: {
        "color": "#000000",
        "round": 1,
        "thickness": 30,
        "dasharray": 0
    },
      width: "4000",
      height: "4000",
      data: "MY QR",
      margin: "0",
      dotsOptions: {
        type: "square",
        colorType: "single-color",
        color: "#000000",
      },
      cornersSquareOptions: {
        type: "square",
        colorType: "single-color",
        color: "#000000",
      },
      cornersDotOptions: {
        type: "square",
        colorType: "single-color",
        color: "#000000",
      },
    };
    const qrCode = new QRCodeStyling(configs);

    qrCode.getRawData("png").then((blob) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64data = reader.result; // Đây là chuỗi base64 (data:image/png;base64,...)
        const upfile = await upload(base64data);

        const id = uuid();

        const newImageLayer = initNewLayer();
        newImageLayer.type = "Image";
        newImageLayer.values[0].file = pick(upfile, ["id", "key"]);
        newImageLayer.imageqrcode = true;
        newImageLayer.personalized = {
          enable: true,
        };
        newImageLayer.QRListStyle = [
          {
            id,
            ...configs,
          },
        ];
        newImageLayer.defaultConfigId = id;
        newImageLayer.title = `Image QR  #${
          layers.filter((l) => l.imageqrcode).length + 1
        }`;
        dispatch({
          type: ARTWORK.ADD_LAYER,
          payload: newImageLayer,
        });
        message.success({
          content: "Successfully created new QR Layer!",
          key,
          duration: 4,
        });
      };
      reader.readAsDataURL(blob);
    });
  };
  return (
    <>
      <Tooltip title="Add Image QR Code">
        <Button
          onClick={addImageQRCode}
          style={{
            width: "100%",
            borderRadius: 0,
            borderLeftWidth: 0,
            padding: 0,
          }}
          icon={<MdQrCode className="anticon" />}
        ></Button>
      </Tooltip>
    </>
  );
};

export default connect((state) => ({
  workspace: state.artwork.workspace,
}))(AddQRCodeLayer);
